export default [
  {
    path: '/otc',
    name: 'fiatdeal',
    redirect: '/otc/center/ordinaryBuy',
    meta: {
      activeName: 'otcTrade',
      pageTitle: 'select', // header
    },
    component: () => import('@/views/otc/index.vue'),
    children: [
      {
        path: '/otc/center/ordinary',
        name: 'OtcCenterOrdinaryBuy',
        redirect: '/otc/center/ordinaryBuy',
        meta: { activeName: 'otcTrade' },
        component: () => import('@/views/otc/center/index.vue'),
      },
      {
        path: '/otc/center/bulk',
        name: 'OtcCenterOrdinaryBuy',
        redirect: '/otc/center/bulkBuy',
        meta: { activeName: 'otcTrade' },
        component: () => import('@/views/otc/center/index.vue'),
      },
      {
        path: '/otc/center/:pageType',
        name: 'OtcCenter',
        meta: { activeName: 'otcTrade' },
        component: () => import('@/views/otc/center/index.vue'),
      },
      {
        path: '/otc/stranger',
        name: 'OtcStranger',
        meta: { activeName: 'otcTrade' },
        component: () => import('@/views/otc/stranger/index.vue'),
      },
      {
        path: '/otc/advertisingManagement',
        name: 'OtcAdvertisingManagement',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/personal/advertisingManagement.vue'),
      },
      {
        path: '/otc/myOrder',
        name: 'OtcMyOrder',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/order/otcOrder.vue'),
      },
      {
        path: '/otc/leaglTenderSet',
        name: 'OtcLeaglTenderSet',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/personal/LeaglTenderSet.vue'),
      },
      {
        path: '/otc/modifySettings',
        name: 'OtcModifySettings',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/personal/modifySettings.vue'),
      },
      {
        path: '/otc/setUp',
        name: 'OtcSetUp',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/personal/SetUp.vue'),
      },
      {
        path: '/otc/otcTrade',
        name: 'OtcOtcTrade',
        meta: { mustLogin: true, isCoOpen: true, activeName: 'otcTrade' },
        component: () => import('@/views/otc/otcTrade/index.vue'),
      },
      {
        path: '/otc/otcRelease',
        name: 'OtcOtcRelease',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/otc/otcRelease/index.vue'),
      },
      {
        path: '/otc/otcDetailOrder',
        name: 'OtcOtcDetailOrder',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/otc/otcDetailOrder/index.vue'),
      },
      {
        path: '/otc/companyApplication',
        name: 'OtcCompanyApplication',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/otc/CompanyApplication/index.vue'),
      },
      {
        path: '/otc/companyApplicationDetail',
        name: 'OtcCompanyApplicationDetail',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/otc/CompanyApplication/detail.vue'),
      },
      {
        path: '/otc/applicationPolicy',
        name: 'OtcApplicationPolicy',
        meta: { mustLogin: true, activeName: 'otcTrade' },
        component: () => import('@/views/otc/CompanyApplication/policy.vue'),
      },
    ],
  },

  // 下边的写法是为了保证兼容性
  // 用户详情页
  {
    path: '/stranger',
    name: 'stranger',
    redirect: '/otc/stranger',
    component: () => import('@/views/otc/index.vue'),
  },
  // 交易页面
  {
    path: '/otcTrade',
    name: 'otcTrade',
    redirect: '/otc/otcTrade',
    component: () => import('@/views/otc/index.vue'),
  },
  // 发布广告
  {
    path: '/otcRelease',
    name: 'otcRelease',
    redirect: '/otc/otcRelease',
    component: () => import('@/views/otc/index.vue'),
  },
  // 订单详情页
  {
    path: '/otcDetailOrder',
    name: 'otcDetailOrder',
    redirect: '/otc/otcDetailOrder',
    component: () => import('@/views/otc/index.vue'),
  },
  // 商家申请初始页
  {
    path: '/companyApplication',
    name: 'companyApplication',
    redirect: '/otc/companyApplication',
    component: () => import('@/views/otc/index.vue'),
  },
  // 商家申请协议确认页
  {
    path: '/companyApplicationDetail',
    name: 'companyApplicationDetail',
    redirect: '/otc/companyApplicationDetail',
    component: () => import('@/views/otc/index.vue'),
  },
  // 商家申请协议页
  {
    path: '/applicationPolicy',
    name: 'applicationPolicy',
    redirect: '/otc/applicationPolicy',
    component: () => import('@/views/otc/index.vue'),
  },
];
